export const SEARCH_HISTORY = 'SEARCH_HISTORY'

export const MAX_SEARCH_QUERIES_STORED = 5
